import React from 'react'

const Education = (props) => {
  return (
    <div className="education mb-5 rounded-[24px] border border-white/8 bg-white/[0.02] p-5">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
        <div className="md:col-span-4">
          <p className="inline-flex rounded-full border border-primary/15 bg-primary/8 px-4 py-2 text-sm font-medium text-primary md:text-base">{props.startYear} - {props.endYear}</p>
        </div>
        <div className="md:col-span-8">
          <h4 className="text-lg md:text-xl mt-0 font-semibold text-base-content">{props.degree}</h4>
          <p className="text-sm md:text-base text-base-content/75"><strong className='text-base-content'>School: </strong>{props.schoolName}</p>
          <p className="text-sm md:text-base text-base-content/75"><strong className='text-base-content'>Major: </strong>{props.major}</p>
        </div>
      </div>
    </div>
  )
}

export default Education
